import { render, staticRenderFns } from "./SetOrganization.vue?vue&type=template&id=ff4dda9a&"
import script from "./SetOrganization.vue?vue&type=script&lang=js&"
export * from "./SetOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports